module.exports = __webpack_public_path__ + "img/71.4.NH3-N.ece5299f.png";